import { CIMSPage } from 'shared'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { HelpMessage } from 'utils/constants'
import { IssueDispositionType } from '../DispositionTypesContext/types'
import { CIMSTags } from 'components/CIMSTags'

export function useColumns(): CIMSColumn<IssueDispositionType>[] {
  return [
    useNameColumn({ help: HelpMessage.Name, sort: { default: 'ascend' } }),
    useOptionalDescriptionColumn('Disposition Type'),
    {
      title: 'Non-Applicable Issue Types',
      link: CIMSPage.IssueTypes,
      help: HelpMessage.Issues.DispositionTypes.NonApplicableIssueTypes,
      render: ({ nonApplicableIssueTypes }) => (
        <CIMSTags
          tags={nonApplicableIssueTypes.map(
            ({ name, description, deleted }) => ({
              text: name,
              tooltip: description,
              strikethrough: deleted,
            })
          )}
        />
      ),
      filter: {
        type: 'default',
        with: 'callback',
        items: (records) =>
          records.flatMap(({ nonApplicableIssueTypes }) =>
            nonApplicableIssueTypes.map(({ id, name, description }) => ({
              text: name,
              value: id,
              tooltip: description,
            }))
          ),
        onFilter: (value, { nonApplicableIssueTypes }) =>
          nonApplicableIssueTypes.some(({ id }) => id === value.toString()),
      },
      width: 250,
    },
  ]
}
